import React, { useMemo } from 'react'
import { StyleSheet } from 'react-native'
import { DNABox, DNAText } from '@alucio/lux-ui'
import { DNACategories } from '@alucio/lux-ui/lib/components/type/DNAText/DNAText'
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors'
import { useCurrentUser } from 'src/state/redux/selector/user'

const S = StyleSheet.create({
  placeholderContainer: {
    borderRadius: 200,
    backgroundColor: colors['color-brand2-600'],
  },
  placeholderContainerUI2: {
    borderRadius: 200,
    backgroundColor: colors['color-ui2-brand-100'],
  },
})

type ProfilePlaceHolderProps = {
  // [TODO]: CLEAN UP OTHER SIZES WHEN CLEANING UP UI2 FEATURE FLAG
  size?: 'small' | 'medium' | 'large' | 'ui2Small' | 'ui2Medium' | 'ui2Large'
}

const sizeMap: {
  [K in Exclude<ProfilePlaceHolderProps['size'], undefined>]: {
    width: number,
    height: number,
    typeSize: DNACategories,
    textStyle: {}
  }
} = {
  ui2Small: {
    height: 32,
    width: 32,
    typeSize: 'p1',
    textStyle: { fontWeight: 'bold', fontSize: 15, color: colors['color-ui2-brand-500'] },
  },
  ui2Medium: {
    height: 40,
    width: 40,
    typeSize: 'h3',
    textStyle: { fontWeight: 'bold', fontSize: 17, color: colors['color-ui2-brand-500'] },
  },
  ui2Large: {
    height: 48,
    width: 48,
    typeSize: 'h3',
    textStyle: { fontWeight: 'bold', fontSize: 20, color: colors['color-ui2-brand-500'] },
  },
  small: { height: 45, width: 45, typeSize: 'h5', textStyle: { marginTop: -1 } },
  medium: { height: 90, width: 90, typeSize: 'h1', textStyle: { marginTop: 1 } },
  large: { height: 135, width: 135, typeSize: 'h1', textStyle: { marginTop: 2, fontSize: 48 } },
}

// Currently serves a placeholder since we have not implemented profile pictures yet
export const ProfilePicture: React.FC<ProfilePlaceHolderProps> = (props) => {
  const { size = 'small' } = props;
  const { userProfile: user } = useCurrentUser();
  const abbreviated = `${user?.givenName.charAt(0)}${user?.familyName.charAt(0)}`

  const categoryProp = {
    [sizeMap[size].typeSize]: true,
  }

  const containerStyle = useMemo(
    () => [S.placeholderContainerUI2, sizeMap[size]],
    [size]
  )

  return (
    <DNABox
      alignX="center"
      alignY="center"
      style={containerStyle}
    >
      <DNAText
        {...categoryProp}
        colorMode="dark"
        style={sizeMap[size].textStyle}
      >
        {abbreviated}
      </DNAText>
    </DNABox>
  )
}

export default ProfilePicture
